export default {
  en: {
    communities: 'Communities',
    community: 'Community',
    aboutCommunity: 'About community',
    yourCommunities: 'Your communities',
    membersSidebar: 'Members',
    private: 'Private',
    privacyTooltip:
      'Posts are only visible to members of this community. New members must be invited and verified.',
    eventsSidebar: 'Upcoming events',
    sharedSuppliers: 'Shared suppliers',
    communitiesList: {
      pageTitle: 'Communities',
      members: '1 member | {n} members',
      selectOne: 'Select a community',
      pending: 'Pending',
    },
    communityPage: {
      pageTitle: '{communityName} community',
      failedLoad: 'Failed to load this community',
    },
    communityMembers: {
      title: '{communityName} members',
      memberSince: 'Member since:',
      searchMembers: 'Search 1 community member... | Search {n} community members...',
      noMatching: 'There are no members matching this search',
    },
    communityOnboarding: {
      pageTitle: 'Risk Ledger',
      label: 'Community',
      join: 'Join your community',
      joinDescription:
        'Risk Ledger will soon be launching community within the product, register your interest early and your Customer Success Manager will be in touch.',
      joinButton: 'Request access',
      trustCommunityPeers: 'A trusted community of peers',
      trustCommunityPeersDescription:
        'Engage with your network of professionals who understand and share your security challenges, creating a trusted environment for collaboration.',
      betterDecisions: 'Make better decisions',
      betterDecisionsDescription:
        'Make more informed security decisions with confidence, leveraging collective insights and peer validation.',
      efficiencyGains: 'Efficiency gains',
      efficiencyGainsDescription:
        'Save time and effort by leveraging signals from the community, avoiding duplication of work and increasing speed of response.',
      accessRequested: 'Access requested - your Customer Success Manager will be in touch',
    },
    communityInvite: {
      pageTitle: 'Risk Ledger',
      label: 'Community',
      join: 'Welcome to communities',
      adminJoin: 'Welcome to the {communityName} community',
      description:
        'Defend-as-One™ alongside your peers on the Risk Ledger network. Be at the forefront of your industry with shared insights and discussion.',
      adminDescription:
        'Risk Ledger will soon be launching community within the product, register your interest early and your Customer Success Manager will be in touch.',
      joinButton: 'View agreement to join',
      joinLabel: 'Your team admin needs to enable communities for you',
      communityManager: 'Community manager',
      members: 'Members',
      accepting: 'Joining {communityName}...',
      memberUserCount: '{n} users',
      pending: 'Pending invites',
      tos: {
        title: 'Join the {communityName} community',
        subTitle: 'Risk Ledger communities agreement',
        description1:
          'Risk Ledger offers clients the opportunity to form and join communities (Communities). Clients who are members (Members) of a community may access organisation data of other members as set out in the table below. Risk Ledger will manage the admission process for new members. Risk Ledger will give existing members of a community notice (either in writing, including by email, or through the service) 7 days before a new member is admitted. If an existing member does not wish to remain in the community following such notification, they may raise any concerns for discussion with Risk Ledger, and/or choose to leave the community.',
        description2:
          'By joining a community: (a) you agree to the sharing of organisation data with other members in this way whether they are existing members of the community, or join later; (b) you warrant, represent, and undertake, that you are entitled to share information with the community in this way; (c) you authorise other members of the community to use the information you share for the purpose of understanding and evaluating security and compliance practices, requirements and risks.',
        dataSharingTitle: 'Data sharing through this community',
        dataSharingText:
          'By joining this community, the following information will be shared with other members of the community.',
        orgInfo: 'Information about your organisation:',
        orgName: 'Organisation name',
        userNames: 'Names and job titles of users',
        orgDate: 'Date your organisation joined the community',
        connInfo: 'Information about your supplier connections*:',
        supplierName: 'Supplier organisation name',
        connDate: 'Date your organisation connected with the supplier',
        criticalityTags: 'Criticality tags',
        confidentialityTags: 'Confidentiality tags',
        piiTags: 'PII tags',
        approvalStatus: 'Approval status',
        thirdSupplierNames:
          'Organisation names of suppliers further up the supply chain (i.e. suppliers of your suppliers), if applicable',
        signals: 'Signals on your assessment of supplier controls*:',
        numberRisks: 'Number of open and closed risks on each control',
        numberRemediations: 'Number and status of remediation requests on each control',
        userPosts: 'Information contained within user posts on the community page:',
        freeText: 'Free text or document uploads provided by users',
        close: 'Go back',
        join: 'Agree & join',
        privateSuppliersDefinition:
          "*This will not be shared for any suppliers you have set as 'private'.",
        viewPrivacySettings: 'View privacy settings',
      },
    },
    relevantPosts: {
      title: 'Community posts',
      search: 'Search {postCount} mentions...',
      allCommunities: 'All communities',
    },
    communityManager: {
      yourManager: 'Your community manager is {managerName}',
    },
    events: {
      rsvp: 'RSVP',
    },
    userAvatar: {
      worksAt: '{jobTitle} at {orgName}',
      editProfile: 'Edit profile',
    },
    welcomeModal: {
      title: 'Welcome to {communityName}',
      text: 'Please agree to the following community guidelines to ensure a safe and productive environment for all community members',
      guideline1: "Don't share sensitive information you do not have permission to share",
      guideline2: 'Consider confidentiality concerns or NDAs you may have in place',
      guideline3: 'Engage respectfully and professionally, avoid offensive or disruptive behaviour',
      guideline4:
        'If you become aware of any violations of these guidelines or any legal issues, report them to your community manager',
      cta: 'Get started',
      title2: 'Set up profile',
      title3: 'Edit profile',
      fullName: 'Full name',
      linkedinFormat: 'Please enter a valid LinkedIn profile link',
      nameInSettings: 'You can update your name in {settings}',
      settings: 'Settings',
      jobTitleDisplay: 'Will be displayed as {title} at {org}',
      uploadPhoto: 'Upload photo',
      uploadInProgress: 'Wait for your photo to finish uploading',
      linkedinPlaceholder: 'linkedin.com/in/your-profile-url',
      getStarted: 'Get started',
      save: 'Save changes',
      error: 'Failed to set profile details. Please try again.',
      agree: 'Agree',
    },
    sharing: {
      invite: 'Invite others to join you by sharing this link',
    },
    trialPlaceholder: {
      title: 'Defend-as-One™ with peers in your industry',
      description:
        'Join a collaborative network of organisations in your industry to share intelligence, establish common standards, and build a stronger collective defense against Emerging Threats.',
      title2: 'Key benefits',
      benefit1: 'Share intelligence about Emerging Threats affecting your sector',
      benefit2: 'Make more informed security decisions with confidence using collective insights',
      benefit3: 'Save time by reducing assessment duplication through shared standards',
      benefit4:
        'Build trusted relationships with professionals who understand your security challenges',
      cta: 'Book a demo',
    },
  },
};
